import { useEffect, useState } from "react";
import { useLiveQuery } from "dexie-react-hooks";
import {
  countUnread,
  listCallLogs,
  listContacts,
  listMessages,
  type CallLogEntry,
  type Contact,
  type Message,
} from "./storage/db.js";
import { onSweep } from "./storage/sweeper.js";

export function useContacts(): Contact[] {
  return useLiveQuery(() => listContacts(), [], []);
}

export function useCallLogs(): CallLogEntry[] {
  return useLiveQuery(() => listCallLogs(), [], []);
}

/** Live count of unread inbound messages, across every conversation. */
export function useUnreadCount(): number {
  return useLiveQuery(() => countUnread(), [], 0);
}

export function useMessages(peerUserId: string | undefined): Message[] {
  return useLiveQuery(
    () => (peerUserId ? listMessages(peerUserId) : Promise.resolve([])),
    [peerUserId],
    [],
  );
}

/** Re-render on an interval so self-destruct countdowns stay live. */
export function useTick(ms = 1000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), ms);
    const off = onSweep(() => setNow(Date.now()));
    return () => {
      clearInterval(t);
      off();
    };
  }, [ms]);
  return now;
}
